const BudgetTracking = {

    // PAGE HEADER
    "budgetTracking": "Budget Tracking",

    // FILTERS
    "premise": "Premise",
    "financial_year": "Financial Year",

    // TABLE COLUMNS
    "table_expense_head": "EXPENSE HEAD",
    "table_budget_amount": "BUDGET AMOUNT",
    "table_expense_amount": "EXPENSE AMOUNT",
    "table_variance_amount": "VARIANCE AMOUNT",
    "table_variance_percentage": "VARIANCE PERCENTAGE",

}

export default BudgetTracking;